import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import CustomerSignup from '../../components/Customer/CustomerSignup';
import ProviderSignup from '../../components/Customer/ProviderSignup';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import SocialSignin from '../../components/Social/SocialSignin';
import AppLinks from '../../components/About/AppLinks';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    bigIndicator: {
        height: 0
    }
});
function TabContainer(props) {
    return <Typography component="div">{props.children}</Typography>;
}

class SignupForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaderButton: false,
            email: '',
            password: '',
            value: 0
        };
    }

    handleClose = () => {
        this.props.closeLoginPopup();
    };
    handleChange = (event, value) => {
        this.setState({ value });
    };
    renderLoginPage = () => {
        this.props.history.push({ pathname: `/user/signin` });
    };
    render() {
        const { value } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <div className="tz-register">
                    <div className="log-in-pop">
                        <div className="log-in-pop-left">
                            <h1>
                                Hello... <span className="ng-binding" />
                            </h1>
                            <p>
                                Don't have an account? Create your account. It's
                                take less then a minutes
                            </p>
                            {value === 0 && (
                                <React.Fragment>
                                    <h4>Login with social media</h4>

                                    <SocialSignin
                                        loginDone={this.handleClose}
                                        isLoginScreenCall={false}
                                        className="dark"
                                    />
                                </React.Fragment>
                            )}
                        </div>
                        <div className="log-in-pop-right">
                            <a
                                href="#"
                                className="pop-close"
                                data-dismiss="modal"
                            />
                            <h4>Create an Account</h4>
                            <p>
                                Don't have an account? Create your account. It's
                                take less then a minutes
                            </p>
                            <div className="s12 ng-pristine ng-valid">
                                <div>
                                    <AppBar
                                        position="static"
                                        color="default"
                                        className="create-account-nav"
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={this.handleChange}
                                            variant="scrollable"
                                            scrollButtons="on"
                                            indicatorColor="primary"
                                            textColor="primary"
                                            centered
                                        >
                                            <Tab
                                                className="btn-tab-account"
                                                label={formatMessage({
                                                    id: 'customer'
                                                })}
                                            />
                                            <Tab
                                                className="btn-tab-account"
                                                label={formatMessage({
                                                    id: 'Provider'
                                                })}
                                            />
                                        </Tabs>
                                    </AppBar>
                                    {value === 0 && (
                                        <TabContainer>
                                            <CustomerSignup />
                                        </TabContainer>
                                    )}
                                    {value === 1 && (
                                        <TabContainer>
                                            <ProviderSignup />
                                        </TabContainer>
                                    )}
                                </div>

                                <div>
                                    <div className="input-field s12">
                                        <a href="javascript:void(0);">
                                            Are you a already member ?
                                            <p onClick={this.renderLoginPage}>
                                                Login
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AppLinks settings={this.props.settings} />
            </div>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return { settings };
};
const composedHOC = compose(
    withTheme(),
    withStyles(styles),
    connect(mapStateToProps, actions)
);
export default composedHOC(withRouter(injectIntl(SignupForm)));



// WEBPACK FOOTER //
// ./src/views/Signup/SignupForm.jsx